import * as React from 'react';
import * as _ from 'underscore';
//import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { FontField } from './FontField';
import SelectField from './SelectField';
import { ColorBoxField } from './ColorBoxField';

import * as appTheme from '../ts/appTheme';

export class FontBoxField extends React.Component<
    {
        value?;
        options: {
            showColor?: boolean;
            showItalic?: boolean; //LL: 27.09.21: added, so False by default
            theme?: appTheme.IValuesCollection;
        };
        glob: IGlob;

        onChange(value): void;
    },
    any
> {
    //LL: 20.01.25 
    private references: {
        italic?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        //  this.props.options.showColor: true
    }

    get_showColor(): boolean {
        let showColor = false; // default
        if (this.props.options != null && this.props.options.showColor != null) {
            showColor = this.props.options.showColor;
        }
        return showColor;
    }

    //LL: 27.09.21
    get_showItalic(): boolean {
        let showItalic = false; // default
        if (this.props.options != null && this.props.options.showItalic != null) {
            showItalic = this.props.options.showItalic;
        }
        return showItalic;
    }

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    changeSize = (val) => {
        let obj = _.clone(this.props.value || {});

        if (val == null) {
            delete obj.size;
        } else {
            obj.size = val;
        }

        this.handleValueChange(obj);
    };

    changeWeight = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.weight;
        } else {
            obj.weight = val;
        }
        this.handleValueChange(obj);
    };

    changeFace = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.face;
        } else {
            obj.face = val;
        }
        this.handleValueChange(obj);
    };

    //LL: 27.09.21
    changeItalic = (e) => {
        let elem: any = this.references.italic;
        let val = elem.checked; //LL: not value

        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.italic;
        } else {
            obj.italic = val;
        }
        this.handleValueChange(obj);
    };

    changeColor = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.color;
        } else {
            obj.color = val;
        }
        this.handleValueChange(obj);
    };

    //LL: 20.05.20: ownKeys
    isOwnKey(ownKeys, propName) {
        let ii = _.indexOf(ownKeys, propName);
        return ii >= 0;
    }

    //LL: 20.05.20: ownKeys
    //createClearOwnElement_Bool(changeFunc) {
    //    let styleClear: any = { marginLeft: "5px", marginRight: "3px" };  //  , marginTop: "4px"  bad
    //    let clearElem =
    //        <span style={styleClear}
    //              className="glyphicon glyphicon-remove"
    //              onClick={ () => { changeFunc(null) } }
    //        >
    //        </span>;
    //    return clearElem;
    //}
    //LL: 20.05.20: ownKeys
    createClearOwnElement(changeFunc) {
        let styleClear: any = { marginLeft: '1px', marginRight: '3px' };
        //  className="clear-button" is inside flex
        let clearElem = (
            <span
                style={styleClear}
                className="glyphicon glyphicon-remove clear-button"
                onClick={() => {
                    changeFunc(null);
                }}
            ></span>
        );
        return clearElem;
    }

    getSize(curValue, ownKeys) {
        let displayVal_size = curValue.size || 'default';
        let options_size = {
            values: [
                'default',
                'xx-small',
                'x-small',
                'small',
                'medium',
                'large',
                'x-large',
                'xx-large',
                'smaller',
                'larger'
            ],
            display: [
                'default',
                'xx-small',
                'x-small',
                'small',
                'medium',
                'large',
                'x-large',
                'xx-large',
                'smaller',
                'larger'
            ]
        };

        let ownKey = this.isOwnKey(ownKeys, 'size');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.changeSize); // className="clear-button"
        }

        return (
            <div className={'size'}>
                <label>Font Size</label>
                <br />
                <div className="inheritedValue">
                    {clearElem}
                    <div className="own-value">
                        <SelectField value={displayVal_size} options={options_size} onChange={this.changeSize} />
                    </div>
                </div>
            </div>
        );
    }

    getWeight(curValue, ownKeys) {
        let displayVal_weight = curValue.weight || 'normal';
        let options_weight = {
            values: ['lighter', 'normal', 'bold', 'bolder'],
            display: ['lighter', 'normal', 'bold', 'bolder']
        };

        let ownKey = this.isOwnKey(ownKeys, 'weight');
        let clearElem;
        if (ownKey) {
            clearElem = this.createClearOwnElement(this.changeWeight); // className="clear-button"
        }

        return (
            <div className={'weight'}>
                <label>{'Font Weight'}</label>
                <br />
                <div className="inheritedValue">
                    {clearElem}
                    <div className="own-value">
                        <SelectField value={displayVal_weight} options={options_weight} onChange={this.changeWeight} />
                    </div>
                </div>
            </div>
        );
    }

    getFace(curValue, ownKeys) {
        //let displayVal_face = curValue.face || '';  // not '' !!!!!
        let displayVal_face = curValue.face || null;

        let ownKey = this.isOwnKey(ownKeys, 'face');
        let clearElem;

        if (ownKey) {
            clearElem = this.createClearOwnElement(this.changeFace); // className="clear-button"
        }

        return (
            <div className={'face'}>
                <label>{'Font Face'}</label>
                <br />
                <div className="inheritedValue">
                    {clearElem}
                    <div className="own-value">
                        <FontField
                            value={displayVal_face}
                            theme={this.props.options?.theme}
                            glob={this.props.glob}
                            onChange={this.changeFace}
                        />
                    </div>
                </div>
            </div>
        );
    }

    //LL: 27.09.21
    getItalic(curValue, ownKeys) {
        let italicElem;

        if (this.get_showItalic()) {
            let fontItalicDefault = false;
            let displayVal = curValue.italic == null ? fontItalicDefault : curValue.italic;

            let ownKey = this.isOwnKey(ownKeys, 'italic');
            let clearElem;
            if (ownKey) {
                clearElem = this.createClearOwnElement(this.changeItalic); // className="clear-button"
            }

            italicElem = (
                <div className={'italic'}>
                    <label>{'Font Italic'}</label>
                    <br />
                    {clearElem}
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <input 
                                ref={(input) => {
                                    this.references.italic = input;
                                }} //LL: 20.01.25 
                                type="checkbox" checked={displayVal} onChange={this.changeItalic} 
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return italicElem;
    }

    getColor(curValue, ownKeys) {
        let colorElem;

        if (this.get_showColor()) {
            let options_color: any = {
                hideTransparency: true
            };

            let param: any = {
                //defaultVal: () => {return themeObj[themeFieldForDefault_color] || defaultColor },
                defaultVal: 'black',
                glob: this.props.glob,
                options: options_color
            };

            let displayVal_color = curValue.color || 'black';

            let ownKey = this.isOwnKey(ownKeys, 'color');
            let clearElem;
            if (ownKey) {
                clearElem = this.createClearOwnElement(this.changeColor); // className="clear-button"
            }

            colorElem = (
                <div className={'color'}>
                    <label>{'Font Color'}</label>
                    <br />
                    <div className="inheritedValue">
                        {clearElem}
                        <div className="own-value">
                            <ColorBoxField
                                glob={this.props.glob}
                                value={displayVal_color}
                                hideTransparency={true}
                                showText={true}
                                options={options_color}
                                param={param}
                                onChange={this.changeColor}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return colorElem;
    }

    render() {
        let curValue = this.props.value;

        //LL: 20.05.20: also see "merger: appTheme.mergerForObjects" in caller

        //LL: 20.05.20: ownKeys - props with these keys will have glyphicon-remove
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentValues_forObjects(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;
        //LL: this is new for object-fields:
        let keysArr = _.keys(ownValues); // _.keys({one: 1, two: 2, three: 3}); => ["one", "two", "three"]
        let ownKeys = [];
        _.each(keysArr, function (obj: any) {
            if (parentValues[obj] == null || parentValues[obj] !== ownValues[obj]) {
                ownKeys.push(obj);
            }
        });

        return (
            <div className="fontBox-field">
                {this.getFace(curValue, ownKeys)}
                {this.getSize(curValue, ownKeys)}
                {this.getWeight(curValue, ownKeys)}
                {this.getItalic(curValue, ownKeys)}
                {this.getColor(curValue, ownKeys)}
            </div>
        );
    }
}
